import {
  getUuid,
  isProd,
  isMobileDevice,
  getUrlAllParams,
  getBrowserName,
} from "../tools.js";
import { formatDate } from "../dateTime.js";
import {
  firebaseInit,
  firebaseLogEvent,
  firebaseSetUserId,
} from "@/utils/analytic/firebaseWrapper.js";
import useUserDataStore from "@/store/userDataStore.js";
import sa from "sa-sdk-javascript";
import { getUseSource } from "@/api/net/config.js";
import globalConfig from "@/config/config.js";
// import sensors from "./sensorsdata.es6.min.js"
import abtest0 from "./abtest.esm.min.js";
// 导出一个初始的 firebaseUtils 对象，包含所有方法的占位实现
export const firebaseUtils = {
  getAnonymousID: async () => {
    return await sa.quick("getAnonymousID");
  },
  logViewEvent: async function (eventName, params = {}) {
    console.warn('firebaseUtils.logViewEvent not initialized yet');
  },
  logClickEvent: async function (eventName, params = {}) {
    console.warn('firebaseUtils.logClickEvent not initialized yet');
  },
  logCustomEvent: async function (eventName, params = {}, eventType) {
    console.warn('firebaseUtils.logCustomEvent not initialized yet');
  },
  logLoginEvent: async function (userId) {
    console.warn('firebaseUtils.logLoginEvent not initialized yet');
  },
  testViewEvent: async function (eventName, params = {}) {
    console.warn('firebaseUtils.testViewEvent not initialized yet');
  },
  abtest: undefined,
};

export default {
  install: (app, options) => {
    let page;
    let referrer = document.referrer;
    var userDataStore = useUserDataStore();
    const env = import.meta.env.VITE_APPNAME ?? "Mureka";
    const firebaseConfig = {
      apiKey: "AIzaSyBcGnuedT7WsyKn05iZphkjIjsAJt-xkz0",
      authDomain: "mureka-35a18.firebaseapp.com",
      projectId: "mureka-35a18",
      storageBucket: "mureka-35a18.appspot.com",
      messagingSenderId: "247728744599",
      appId: "1:247728744599:web:18ebbaca5995b7ae8ba1d2",
      measurementId: "G-FY4GZWS3Q4",
    };

    firebaseInit(firebaseConfig);
    const pointInitFunc = async function (_page) {
      var gaUserId = document.cookie
        .match(/_ga=(.+?);/)[1]
        .split(".")
        .slice(-2)
        .join(".");
      console.log("gaUserId", gaUserId);
      firebaseSetUserId(gaUserId ?? "");

      page = _page;
      referrer = document.referrer;
    };
    const url = `https://sa.yinhe.top/sa?project=${
      isProd() ? "mureka" : "mureka-test"
    }&token=Ehp5cUw99q6lSxOm4`;
    const urlCn = `https://sa.yinhe.top/sa?project=${
      isProd() ? "murekacn" : "murekacn-test"
    }&token=Ehp5cUw77q6lSxOm4`;

    sa.init({
      server_url: env == "Mureka" ? url : urlCn, // 替换成你的神策数据接收地址
      is_track_single_page: true,
      heatmap: {
        clickmap: "not_collect",
        scroll_notice_map: "default",
      },
      abtest: {
        enable_auto_track: true, // 启用自动上报
      },
    });

    const gaInfo = document.cookie?.match(/_ga=(.+?);/)?.[1] ?? "";
    sa.registerPage({
      platform: globalConfig.platform,
      firebase_id: gaInfo ?? "",
      $browser: getBrowserName(),
    });

    sa.quick("autoTrack");

    const abtest = sa.use("SensorsABTest", {
      url: globalConfig.abtestUrl,
      multilink: false,
    });

    const assignParams = (params, eventType) => {
      const useSource = getUseSource();
      let data = Object.assign(params, {
        referrer,
        // userId: userId.toString(),
        traceid: getUuid(),
        // source: page,
        date: formatDate(new Date(), "YYYY-MM-DD hh:mm:ss:c"),
        event: eventType ?? "custom",
        source_type: useSource ? useSource.split("_")[0] : "",
        ad_source: useSource ?? "",
        // isMobileDevice: isMobileDevice(),
        ad_bd_vid: getBdVid() ?? "",
      });
      return data;
    };

    const getBdVid = () => {
      const adSourceStorage = window.sessionStorage.getItem("ad_source");
      if (!adSourceStorage) return null;

      const { bd_vid } = JSON.parse(adSourceStorage);
      return bd_vid || null;
    };

    // 页面或组件展示打点
    const logViewEvent = async function (eventName, params = {}) {
      const log_type = "show";
      firebaseLogEvent(
        `${eventName}_${log_type}`,
        assignParams(params, log_type)
      );
      sa.track(`${eventName}_${log_type}`, assignParams(params, log_type));
      console.log(
        "埋点🍎🍎🍎🍎🍎🍎🍎",
        `${eventName}_${log_type}`,
        assignParams(params, log_type)
      );
    };

    // 点击事件打点
    const logClickEvent = async function (eventName, params = {}) {
      const log_type = "click";
      if (params?.content_id != undefined) {
        params.content_id = params?.content_id.toString();
      }
      firebaseLogEvent(
        `${eventName}_${log_type}`,
        assignParams(params, log_type)
      );
      sa.track(`${eventName}_${log_type}`, assignParams(params, log_type));
      console.log(
        "埋点🍎🍎🍎🍎🍎🍎🍎",
        `${eventName}_${log_type}`,
        assignParams(params, log_type)
      );
    };

    const logCustomEvent = async function (eventName, params = {}, eventType) {
      if (params?.content_id != undefined) {
        params.content_id = params?.content_id.toString();
      }
      firebaseLogEvent(
        `${eventName}_${eventType}`,
        assignParams(params, eventType)
      );
      sa.track(
        `${eventName}${eventType ? "_" + eventType : ""}`,
        assignParams(params, eventType)
      );
      console.log(
        "埋点🍎🍎🍎🍎🍎🍎🍎",
        `${eventName}${eventType ? "_" + eventType : ""}`,
        assignParams(params, eventType)
      );
    };

    const testViewEvent = async function (eventName, params = {}) {
      firebaseLogEvent(`pre_register`);
    };

    const logLoginEvent = async function (userId) {
      if (userId) {
        sa.login(userId.toString());
      }
    };
    // 页面曝光埋点  page: 页面名称，origin: 页面入口：董老师的传mureka 慕阳 的传create
    app.config.globalProperties.logPageMounted = async function (
      page,
      params = {}
    ) {
      if (params?.content_id != undefined) {
        params.content_id = params?.content_id.toString();
      }
      pointInitFunc(page, params);
      logViewEvent(page, params);
    };
    // 组件曝光 入参 埋点名
    app.config.globalProperties.logViewEvent = logViewEvent;
    // 点击事件 入参 埋点名
    app.config.globalProperties.logClickEvent = logClickEvent;

    app.config.globalProperties.logCustomEvent = logCustomEvent;

    Object.assign(firebaseUtils, {
      logViewEvent,
      logClickEvent,
      logCustomEvent,
      logLoginEvent,
      testViewEvent,
      abtest,
    });
  },
};
